module.exports = __webpack_public_path__ + "img/Beit_Bakfar.207c3ebd.svg";